import { useEffect } from 'react';
import { graphql, useQuery } from '@/lib/graphql';
import { useSetAtom } from 'jotai';
import { networkAtom } from '@/features/connect-dots/atoms/networkAtom';

const GET_NETWORK_QUERY = graphql(`
  query getTopicTagGraph {
    topicTagGraph {
      nodes {
        id
        label
        description
        value
        weight
        frequency
        isAssist
        isSocialIssue
        nodeType
        themes
        keywords
      }
      edges {
        id
        source
        target
        weight
        label
      }
    }
  }
`);

export const useNetworkData = () => {
  const setNetwork = useSetAtom(networkAtom);

  const { data, loading, error } = useQuery(GET_NETWORK_QUERY, {
    errorPolicy: 'all',
  });

  const finalNetwork = {
    nodes: data?.topicTagGraph?.nodes ?? [],
    edges: data?.topicTagGraph?.edges ?? [],
  };

  // Jotai atomにキャッシュ
  useEffect(() => {
    setNetwork(finalNetwork);
  }, [finalNetwork, setNetwork]);

  return {
    network: finalNetwork,
    isLoading: loading,
    error,
  };
};
